import React from 'react';
import styled, { withTheme } from 'styled-components';
import ReactLoading from 'react-loading';

const Loading = props => {
  return (
    <StyledLoading>
      <ReactLoading color={props.theme.primary} type={'bubbles'} />
    </StyledLoading>
  );
};

export default withTheme(Loading);

const StyledLoading = styled.div`
  width: 5em;
  margin: 2em auto;
`;
